import { EmployeeServicePath, BUSINESS_TRIPS } from "utils/constants";
import EditBusinessTrips from "./Edit";
import permissions from "app/permissions";

export const resources = {
  isMenu: false,
  name: EmployeeServicePath + "edit/" + BUSINESS_TRIPS + "/:id",
  title: "Редакция на командировка",
  custom: <EditBusinessTrips />,
  permission: permissions.canUpdateLeaveRequests,
};
